import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowSnackbar: Components<Theme>['MuiSnackbar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [theme.breakpoints.up('sm')]: {
        // responsive
        maxWidth: `calc(100% - ${24 * 2}px)`,
        minWidth: '320px',
      },
    }),
  },
};
